/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CompanyService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '../../services/wealthlane-award-services';

const usePostTransactionConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        CompanyService.putApiAwardApiAppCompanyCompanyConfiguration(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response?.isSuccess) {
          await queryClient.invalidateQueries('getTransactionConfiguration');
          toast.success(
            <ToastComponent
              label='Success'
              message={`Transaction Configuration Updated Successfully`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
        toast.error(
          <ToastComponent label='Error' message='Failed to save transaction configuration' />
        );
      },
    }
  );
};

export default usePostTransactionConfiguration;
